export enum EnumEnrollmentState {
  "draft" = "draft",
  "published" = "published",
  "publishing" = "publishing",
  "pending" = "pending",
  "active" = "active",
  "closed" = "closed",
}
